if (!customElements.get('mobile-snap-rail')) {
  customElements.define('mobile-snap-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-mobile-rail]');
      if (!this.rail) return;
      this.desktopTabindex = this.rail.getAttribute('tabindex');
      this.slides = Array.from(this.rail.children);
      this.roles = this.slides.map((slide) => slide.getAttribute('role'));
      this.controls = this.querySelector('[data-mobile-rail-controls]');
      this.previous = this.querySelector('[data-mobile-prev]');
      this.next = this.querySelector('[data-mobile-next]');
      this.position = this.querySelector('[data-mobile-position]');
      this.mobile = matchMedia('(max-width: 767.98px)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.rail.addEventListener('scroll', () => this.sync(), { ...options, passive: true });
      this.rail.addEventListener('keydown', (event) => {
        if (!this.mobile.matches || event.target !== this.rail) return;
        const keys = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.go(keys[event.key]);
      }, options);
      this.mobile.addEventListener('change', () => this.sync(), options);
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this.rail);
      this.synced = null;
      this.sync();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }

    sync() {
      const mobile = this.mobile.matches;
      const edge = this.rail.getBoundingClientRect().left;
      const distances = this.slides.map((slide) => Math.abs(slide.getBoundingClientRect().left - edge));
      const index = distances.indexOf(Math.min(...distances));
      if (this.synced === `${mobile}:${index}`) return;
      this.synced = `${mobile}:${index}`;
      this.index = index;
      this.controls.hidden = !mobile || this.slides.length < 2;
      if (mobile) this.rail.setAttribute('tabindex', '0');
      else if (this.desktopTabindex !== null) this.rail.setAttribute('tabindex', this.desktopTabindex);
      else this.rail.removeAttribute('tabindex');
      this.slides.forEach((slide, index) => {
        slide.inert = mobile && index !== this.index;
        if (mobile) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}`);
          slide.setAttribute('aria-roledescription', 'slide');
        } else {
          if (this.roles[index]) slide.setAttribute('role', this.roles[index]);
          else slide.removeAttribute('role');
          slide.removeAttribute('aria-label');
          slide.removeAttribute('aria-roledescription');
        }
        if (slide.inert) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index >= this.slides.length - 1;
      this.dispatchEvent(new CustomEvent('mobile-rail:change', { bubbles: true }));
    }

    go(index) {
      const slide = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
      if (!slide) return;
      this.rail.scrollBy({ left: slide.getBoundingClientRect().left - this.rail.getBoundingClientRect().left,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}
